/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { FolderCertIcon16Light } from './FolderCertIcon16Light';
import { FolderCertIcon16Regular } from './FolderCertIcon16Regular';
import { FolderCertIcon16Solid } from './FolderCertIcon16Solid';
import { FolderCertIcon20Light } from './FolderCertIcon20Light';
import { FolderCertIcon20Regular } from './FolderCertIcon20Regular';
import { FolderCertIcon20Solid } from './FolderCertIcon20Solid';
import { FolderCertIcon24Regular } from './FolderCertIcon24Regular';
import { FolderCertIcon24Solid } from './FolderCertIcon24Solid';
import { FolderCertIcon32Regular } from './FolderCertIcon32Regular';
import { FolderCertIcon64Regular } from './FolderCertIcon64Regular';
var sizes = {
    16: {
        light: FolderCertIcon16Light,
        regular: FolderCertIcon16Regular,
        solid: FolderCertIcon16Solid,
    },
    20: {
        light: FolderCertIcon20Light,
        regular: FolderCertIcon20Regular,
        solid: FolderCertIcon20Solid,
    },
    24: {
        regular: FolderCertIcon24Regular,
        solid: FolderCertIcon24Solid,
    },
    32: {
        regular: FolderCertIcon32Regular,
    },
    64: {
        regular: FolderCertIcon64Regular,
    },
};
export var FolderCertIcon = forwardRef('FolderCertIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
